function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { translations } from "mirador-downloaddialog";
export default {
  de: _extends({}, translations.de, {
    wholeDocument: "Gesamtes Digitalisat/Volltext"
  }),
  en: _extends({}, translations.en, {
    wholeDocument: "Complete object/full text"
  })
};